export default __webpack_public_path__ + "static/media/MD.01c760d5.svg";